import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { rgba } from 'polished';
import styled from 'styled-components';
import FormStyles from '../Forms/Form.styles';
const Container = styled.div `
  &[aria-disabled='true'] {
    opacity: 0.5;
  }

  &[data-site='ess'] {
    --iconColour: ${brand.ess.primary};
    --bgColour: ${rgba(brand.ess.secondary.midGrey, 0.1)};
  }

  &[data-site='mep'] {
    --iconColour: ${brand.mep.secondary.darkestGrey};
    --bgColour: ${brand.global.white};
  }

  ${FormStyles.Field} {
    align-items: flex-start;
  }
`;
const Inner = styled.span `
  display: inline-flex;
  align-items: center;
`;
const Value = styled.div `
  display: inline-flex;
  width: 33px;
  height: ${fluid(42, 46)};
  font-size: ${fluid(14, 18)};
  line-height: ${fluid(20, 26)};
  align-items: center;
  justify-content: center;
  background-color: var(--bgColour);

  ${Container}[data-site='ess'] & {
    ${fonts.daxWide.bold};
  }

  ${Container}[data-site='mep'] & {
    ${fonts.daxWide.medium};
  }
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('opacity', 0.2)};

  display: inline-flex;
  height: ${fluid(42, 46)};
  width: ${fluid(24, 32)};
  align-items: center;
  justify-content: center;
  color: var(--iconColour);
  background-color: var(--bgColour);

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 1px;
    outline-style: solid;
  }

  &.focus-ring,
  &:not(:disabled):hover {
    opacity: 0.7;
  }

  > svg {
    width: 14px;
    height: 14px;
  }

  ${Container}[data-site='mep'] & {
    &:first-of-type {
      border-radius: 50px 0 0 50px;

      > svg {
        transform: translateX(15%);
      }
    }

    &:last-of-type {
      border-radius: 0 50px 50px 0;

      > svg {
        transform: translateX(-15%);
      }
    }
  }
`;
const QuantitySelectorStyles = {
    Container,
    Button,
    Value,
    Inner,
};
export default QuantitySelectorStyles;
